// initial state
const state = {
    user: {},
    token: null,
    navTitle: null,
    serviceVersion: 'unknown',
    statusList :[{id:0, name:"flexiapp.status.sent"}, {id:1, name:"flexiapp.status.assigned"}, {id:2, name:"flexiapp.status.inprogress"}, {id:3, name:"flexiapp.status.completed"}, 
      {id:4, name:"flexiapp.status.syncpending"}, {id:5, name:"flexiapp.status.finished"},{id:6, name:"flexiapp.status.confirmed"}],
    pendingOfflineUploadImageCount: 0,
    pendingOfflineUploadImages :[],
    workorderEvent:null,
    networkType:null,
    //isWifiAvailable:true,
    isNetworkAvailable:true,
}



// getters
const getters = {
}

// actions
const actions = {
}

// mutations
const mutations = {
  setToken(state, token) {
    state.token = token;
  },
  setUser(state, user) {
    state.user = user;
  },
  setNavTitle(state, navTitle) {
    state.navTitle = navTitle;
  },
  setPendingOfflineUploadImageCount(state, pendingOfflineUploadImageCount) {
    state.pendingOfflineUploadImageCount = pendingOfflineUploadImageCount;
  },
  onWorkorderEvent(state, event){
      state.workorderEvent=event;
  },
  onNetworkEvent(state, event){
      state.networkType=event;
      if(event){
          //state.isWifiAvailable=event.includes('WiFi');
          state.isNetworkAvailable=!event.includes('No network');
      }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}